import styled from "styled-components";
import { pxToRem } from "styles/utils";

export const Container = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${pxToRem(16)};
  padding: ${pxToRem(24)};
  text-align: center;
  background: ${({ theme }) => theme.colors.canvas};
`;

export const Title = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.inkHex};
  font-size: ${pxToRem(24)};
  font-weight: 700;
`;

export const Message = styled.p`
  max-width: ${pxToRem(420)};
  margin: 0;
  color: ${({ theme }) => theme.colors.grayStrong};
  font-size: ${pxToRem(14)};
  line-height: 1.5;
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${pxToRem(12)};
`;

export const ActionButton = styled.button`
  padding: ${pxToRem(12)} ${pxToRem(20)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.brandDark};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  color: ${({ theme }) => theme.colors.whiteHex};
  background: ${({ theme }) => theme.colors.brandDark};
  font-size: ${pxToRem(14)};
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.brandDarker};
  }
`;

export const SecondaryButton = styled(ActionButton)`
  color: ${({ theme }) => theme.colors.brandDark};
  background: ${({ theme }) => theme.colors.whiteHex};

  &:hover {
    background: ${({ theme }) => theme.colors.brandTint};
  }
`;

export const Details = styled.details`
  max-width: ${pxToRem(640)};
  margin-top: ${pxToRem(8)};
  color: ${({ theme }) => theme.colors.grayMuted};
  font-size: ${pxToRem(12)};
  text-align: left;
  white-space: pre-wrap;
  word-break: break-word;
`;
